export const getRequiredBrands = (section, brands) => {
  const sectionData = brands.find((b) => b.section === section);
  const _brands = sectionData ? sectionData.brands : [];
  const brandsNames = _brands.map((b) => b.name);
  // console.log(`Extracted brands for section '${section}':`, brandsNames);
  return brandsNames.length > 0 ? brandsNames : [];
};
